var View = require('views/base/view')
var Model = require('models/formData')

module.exports = View.extend({
  autoRender: true,
  className: 'home-page',
  template: require('./templates/graph'),

  initialize: function () {
   // $('body').on('mouseup', this.hideDetails);
    this.model = this.model || new Model()
    var that = this;
    _(function(){
      that.graphique();
    }).defer();
  },

  events: {
    'click #btnPrint': 'printResult'
  },

  listen: {
    'change model': 'render'
  },

  getTemplateData: function () {
    return {
      cotisSupp: this.model.get('cotisAnnuel'),
      ecoImp: this.model.get('ecoImpEstime'),
      effort: this.calcEffort()
    }
  },

  afterRender: function () {
   // this.graphique();
  },

  render: function () {
    View.prototype.render.apply(this, arguments)
  },

  calcEffort: function () {
    var effort = this.model.get('cotisAnnuel') - this.model.get('ecoImpEstime')

    return effort
  },

  graphique: function () {
    var cotisSupp = this.model.get('cotisAnnuel')
    var ecoImp = this.model.get('ecoImpEstime')
    var effort = cotisSupp - ecoImp

    var cotisSerie = {
      name: 'Cotisation',
      data: [cotisSupp, 0]
    }
    var ecoSerie = {
      name: 'Economie d\'impôt',
      data: [0, ecoImp]
    }
    var effortSerie = {
      name: 'Effort d\'épargne',
      data: [0, effort]
    }

    this.$('#chartContainer').highcharts({
      chart: {
        type: 'column'
      },
      tooltip: {
        formatter: function () {
          return this.series.name + ': <b>' + accounting.formatMoney(this.y, {
            symbol: '€',
            precision: 0,
            thousand: ' ',
            decimal: '.',
            format: '%v %s'
          }) + '</b>'
        }
      },
      title: {
        text: null
      },
      xAxis: {
        labels: {
          enabled: false
        }
      },
      yAxis: {
        min: 0,
        title: {
          text: null
        },
        stackLabels: {
          enabled: false
        }
      },
      plotOptions: {
        column: {
          stacking: 'normal',
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          showInLegend: true
        }
      },
      series: [cotisSerie, ecoSerie, effortSerie]
    })

    this.$('div.highcharts-container text:contains("Highcharts.com")').hide()
  },

  printResult: function () {
    window.print()
  }
})